import { motion } from "framer-motion";
import { Clock, MapPin, CalendarPlus, Navigation } from "lucide-react";
import { calendarUrl, MAPS_URL } from "@/lib/party";

const EASE = [0.16, 1, 0.3, 1];

const rise = {
  hidden: { opacity: 0, y: 26 },
  show: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.9, ease: EASE, delay: i * 0.12 },
  }),
};

function Reveal({ i = 0, className, children }) {
  return (
    <motion.div
      className={className}
      custom={i}
      variants={rise}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, amount: 0.15 }}
    >
      {children}
    </motion.div>
  );
}

export default function Details() {
  return (
    <section className="section" id="dettagli" data-testid="details-section">
      <div className="section-inner">
        <Reveal>
          <div className="section-eyebrow">Una notte da ricordare</div>
          <h2 className="section-title">I dettagli della serata</h2>
          <p className="section-lede">
            Un brindisi, una festa, un nuovo inizio — ti aspettiamo per
            festeggiare i diciotto anni di Ginevra.
          </p>
        </Reveal>

        <div className="detail-rows">
          <Reveal i={1} className="detail-row">
            <Clock size={16} strokeWidth={1.8} />
            <span>
              Dalle ore <strong>20:00</strong> fino a tardi
            </span>
          </Reveal>
          <Reveal i={2} className="detail-row">
            <MapPin size={16} strokeWidth={1.8} />
            <span>
              <strong>Casa Aurora</strong> · Cascina
            </span>
          </Reveal>
        </div>

        <Reveal i={3} className="action-row">
          <a
            className="action-btn"
            data-testid="calendar-button"
            href={calendarUrl()}
            target="_blank"
            rel="noopener noreferrer"
          >
            <CalendarPlus size={15} strokeWidth={1.8} />
            <span>Aggiungi al calendario</span>
          </a>
          <a
            className="action-btn"
            data-testid="maps-button"
            href={MAPS_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Navigation size={15} strokeWidth={1.8} />
            <span>Indicazioni su Maps</span>
          </a>
        </Reveal>
      </div>
    </section>
  );
}
